import { render, staticRenderFns } from "./supplier-mtl.vue?vue&type=template&id=e8094c9e&scoped=true"
import script from "./supplier-mtl.vue?vue&type=script&lang=js"
export * from "./supplier-mtl.vue?vue&type=script&lang=js"
import style0 from "./supplier-mtl.vue?vue&type=style&index=0&id=e8094c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8094c9e",
  null
  
)

export default component.exports